import { TFunctionType } from 'shared/entities/localization';

type Params = {
  unreadConversationsCount: number;
  noteMentionsCount: number;
  slaViolationsCount: number;
  slaWarningsCount: number;
};

/**
 * Заголовок не сводится к одной проверке уровня: правила источников остаются
 * раздельными. Нарушение SLA всегда вытесняет непрочитанные и упоминания,
 * предупреждение показывается только когда релевантных непрочитанных нет,
 * а иначе действуют прежние правила EPIC-18 — приоритет непрочитанных над
 * упоминаниями.
 */
export const getTabTitleCounter = (
  t: TFunctionType,
  {
    unreadConversationsCount,
    noteMentionsCount,
    slaViolationsCount,
    slaWarningsCount
  }: Params
): string | null => {
  if (slaViolationsCount > 0) {
    return t('tabIndicator.slaViolations', {
      ns: 'stores',
      count: slaViolationsCount
    });
  }

  if (unreadConversationsCount > 0) {
    return t('tabIndicator.unreadConversations', {
      ns: 'stores',
      count: unreadConversationsCount
    });
  }

  if (slaWarningsCount > 0) {
    return t('tabIndicator.slaWarnings', {
      ns: 'stores',
      count: slaWarningsCount
    });
  }

  if (noteMentionsCount > 0) {
    return t('tabIndicator.newMentions', {
      ns: 'stores',
      count: noteMentionsCount
    });
  }

  return null;
};
